import React, { SyntheticEvent } from 'react';
import cx from 'classnames';

import './gradient-progress-column.css';

interface Props {
    children?: string | JSX.Element | JSX.Element[];
    color: 'aqua';
    handleCancel?(): void;
    progress: number;
}

/**
 * A progress bar that fills in a column, using a gradient, from the bottom to the top.
 */
export const GradientProgressColumn = ({
    children,
    color,
    progress,
    handleCancel,
}: Props): JSX.Element => {
    const classNames = cx(
        'gradient-progress-column',
        color,
        'p12',
        'h-full',
        'flex',
        'flex-col',
    );

    return (
        <div className={classNames}>
            <div className="progress-container p-12 flex-auto relative opacity-75">
                <div className="flex flex-col justify-center w-full h-full">
                    <div className="flex-auto flex flex-col justify-center items-center">
                        {children}
                    </div>
                </div>
                <div
                    className="absolute bottom-0 left-0 progress-meter opacity-50 w-full"
                    style={{
                        height: `${progress}%`,
                    }}
                />
                {handleCancel && (
                    <div className="flex justify-center">
                        <button
                            type="button"
                            className="respond-to-mouse font-bold underline"
                            onClick={(e: SyntheticEvent): void => {
                                e.preventDefault();
                                handleCancel();
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};
